import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { FilterUpdate911Model, FilterRate911Model, FilterUpdateModel, FilterRate911V2Model } from 'src/Models/Update911Model';

@Injectable({
  providedIn: 'root'
})
export class Updates911Service {
  AppUrl = '';
  FilterUpdate911Model = new FilterUpdate911Model();
  FilterRate911Model = new FilterRate911Model();
  FilterRate911V2Model = new FilterRate911V2Model();
  filterUpdateModel = new FilterUpdateModel();
  constructor(private readonly _http: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
      this.AppUrl = sessionStorage.getItem('BaseURL') || '';
    }
  }
  UpdateAddUpdate(TokenKey: string, addNewActionModel: any): Observable<any> {
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/main911/UpdateAddUpdate';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, addNewActionModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetFund(TokenKey: string, stateId: string, isAdmin: boolean, isEdit: boolean): Observable<any> {
    this.setAPIUrl();
    this.FilterUpdate911Model = {
      pageNumber: 1,
      pageSize: 10,
      stateID: stateId,
      filterText: null,
      fundTypeID: null,
      orderBy: null,
      isAdmin,
      isEdit
    };
    const data = 'api/main911/GetFund';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, this.FilterUpdate911Model, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetRateByStateId(TokenKey: string, stateId: string, isActive: number, scopeId: string) {
    this.FilterRate911Model = {
      stateId,
      isActive,
      scopeId
    };
    this.setAPIUrl();
    const data = 'api/main911/GetRateByStateId';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, this.FilterRate911Model, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetAllUpdate(TokenKey: string, PageNumber: number, PageSize: number, rateId: string, stateId: string, OrderBy: string, userId: number, isFavorite: number,_isExport:boolean) {
    this.filterUpdateModel = {
      pageNumber: PageNumber,
      pageSize: PageSize,
      rateId,
      stateId,
      orderBy: OrderBy,
      userId,
      isFavorite,
      IsExport:_isExport
    };
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/main911/GetAllUpdate';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, this.filterUpdateModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetUpdateById(TokenKey: string, updateId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/main911/GetUpdateById/' + updateId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  DeleteUpdate(TokenKey: string, updateId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/main911/DeleteUpdate/' + updateId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetAllUpdateFront(TokenKey: string, PageNumber: number, PageSize: number, rateId: string, stateId: string, OrderBy: string, userId: number, isFavorite: number) {
    this.filterUpdateModel = {
      pageNumber: PageNumber,
      pageSize: PageSize,
      rateId,
      stateId,
      orderBy: OrderBy,
      userId,
      isFavorite
    };
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/main911/GetAllUpdateFront';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, this.filterUpdateModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetRateByStateIdV2(TokenKey: string, stateId: number, countyId: number, cityId: number, scopeId: number) {
    this.FilterRate911V2Model = {
      stateId,
      countyId,
      cityId,
      scopeId
    };
    this.setAPIUrl();
    const data = 'api/main911/V2/GetRateByStateId';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(this.AppUrl + data, this.FilterRate911V2Model, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error.message || error);
    return observableThrowError(() => error.status);
  }
}
